import React from 'react';
import amcStyles from '../../styles/amcs.scss';

interface ReturnsDropdownProps {
  handleChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  selectedValue?: string;
}

const ReturnsDropdown: React.FC<ReturnsDropdownProps> = ({
  handleChange,
  selectedValue = 'return5yr',
}) => {
  return (
    <div className="lil-flex lil-items-center lil-mr-4 sm:lil-mr-0">
      <label className="lil-text-s-14 lil-text-font-500 lil-font-medium">
        Returns:
      </label>
      <select
        onChange={handleChange}
        value={selectedValue}
        className={`lil-ml-4 lil-text-s-12 sm:lil-text-s-14 lil-text-font-200 lil-font-normal lil-px-2 lil-py-1 lil-outline-none lil-bg-white lil-border lil-border-gray-300 lil-rounded ${amcStyles['selectDropdown']}`}
      >
        <option value="return5yr">5Y</option>
        <option value="return3yr">3Y</option>
        <option value="return1yr">1Y</option>
        {/* <option value="return6mth">6M</option> */}
        <option value="return3mth">3M</option>
        <option value="return1mth">1M</option>
      </select>
    </div>
  );
};

export default ReturnsDropdown;



// WEBPACK FOOTER //
// ./components/amcNew/ReturnsDropdown.tsx